import { FC, Fragment } from 'react';
import { ProposalTransfer } from 'ts/shared/interfaces/ProposalData';
import { useTranslation } from 'react-i18next';
import useRemovedItem from './useRemovedItem';
import ProposalEditHead from './ProposalEditHead';
import { checkAHAVI, dateFormat } from 'utils/utils';

interface ProposalTrfProps {
  transfers: ProposalTransfer[];
  displayPrice: boolean;
  proposalId: string;
}

const ProposalTrf: FC<ProposalTrfProps> = ({ transfers, proposalId, ...props }) => {
  const { t } = useTranslation();
  const removedItem = useRemovedItem(proposalId);
  return (
    <div className="pr-hotel-card-wr">
      <div className={'pr-hotel-card pr-break-avoid' + (removedItem ? ' pr-hotel-removed' : '')}>
        <div className="pr-hotel-card-title pr-flex-between">
          <div className="pr-flex-row">
            <div className="pr-flex-row">{t('transfer.transfer')}:</div>
            <div className="pr-ph-5">
              {transfers[0].pickUpDetails.airport?.code || transfers[0].pickUpDetails.city?.desc} -{' '}
              {transfers[0].dropOffDetails.airport?.code || transfers[0].dropOffDetails.city?.desc},{' '}
              {dateFormat(transfers[0].pickUpDate, 'dd/MM/yyyy HH:mm', 'en')}
            </div>
          </div>
          <ProposalEditHead proposalId={proposalId} displayPrice={props.displayPrice} />
        </div>

        {transfers.map((transfer, index) => (
          <div className="pr-lh">
            {index > 0 && <div className="pr-divider"></div>}
            <div className="pr-flex-row">
              <div className="pr-w-100">{t('passenger.s')}</div>
              <div className="pr-bold">
                {transfer.adult} {t('search.adults')}
                {!!transfer.cnn && `, + ${transfer.cnn} {t('search.children')}`}
              </div>
            </div>

            <div className="pr-flex-row">
              <div className="pr-w-100">{t('transfer.pick_up')}</div>
              <div className="pr-bold">
                {dateFormat(transfer.pickUpDate, 'dd MMM, yyyy HH:mm', 'en')}
              </div>
            </div>

            <div className="pr-flex-row">
              <div className="pr-w-100">
                {t('from')} - {t('to')}
              </div>
              <div className="pr-bold">
                {transfer.pickUpDetails.address} - {transfer.dropOffDetails.address}
              </div>
            </div>

            <div className="pr-flex-row">
              <div className="pr-w-100">{t('transfer.vehicle')}</div>
              <div className="pr-bold">{transfer.transferVehicle.vehicle.desc}</div>
            </div>

            {transfer.displayNote?.name && (
              <Fragment>
                <div className="pr-h-10"></div>
                <div
                  className={
                    'pr-notes' + (checkAHAVI(transfer.displayNote?.name) ? ' pr-rtl' : ' pr-ltr')
                  }
                >
                  <span className="pr-mr-5">{t('notes')}: </span>{' '}
                  <span
                    className="pr-bold"
                    dangerouslySetInnerHTML={{
                      __html: transfer.displayNote?.name.replace(/\n/g, '<br />'),
                    }}
                  ></span>
                </div>
              </Fragment>
            )}
          </div>
        ))}
      </div>
      <div className="pr-divider"></div>
    </div>
  );
};

export default ProposalTrf;
